/**
 * The minimized canvas chat: the shared FloatingChat FAB pinned inside the
 * React Flow shell (not viewport-fixed) so it respects the explorer /
 * right-pane layout like the rest of the canvas chat, plus the canvas
 * onboarding spotlight target. See `FloatingChatFab` for the shell behavior
 * (activity pulse, left-dock `dockStyle` escape).
 */
import { FloatingChatFab } from "@/components/FloatingChat/FloatingChatFab";
import { SHELL_CONTAINER_FIXED_ESCAPE_CLASS } from "@/components/FloatingChat/floatingChatShell";
import { cn } from "@/utils";
import type { CSSProperties } from "react";

export function CanvasChatFab({
  onOpen,
  running,
  dockStyle,
}: {
  onOpen: () => void;
  /** A run is in progress — pulse the launcher so activity isn't missed. */
  running: boolean;
  /**
   * When set, the launcher pins to the LEFT (viewport-fixed) instead of the
   * shell's bottom-right — used while a full-width detail pane occupies the
   * right. The caller computes the geometry from the canvas content area.
   */
  dockStyle?: CSSProperties;
}) {
  return (
    <FloatingChatFab
      onOpen={onOpen}
      running={running}
      dockStyle={dockStyle}
      data-onboarding-target="agent-chat-toggle"
      cornerClassName={cn(
        "absolute bottom-4 right-4 z-30",
        // Mirror the window shell: below 400px the React Flow container is
        // too narrow, so pin to the viewport instead (matches CORNER_SHELL_CLASS).
        SHELL_CONTAINER_FIXED_ESCAPE_CLASS,
      )}
    />
  );
}
